import * as Moment from 'moment'
import * as Redux from 'redux'
import * as Request from '../../request'
import * as IsActive from '../is_active'
import * as Types from './types'

export interface DatedInformationPayload
  extends Request.RequestOptions { payload: {selectedDate: Types.SelectedDate, filter?: IsActive.Filter } }

export type DatedInformationAction = Request.RequestAction<DatedInformationPayload>

export type DatedInformationActionCreator =
  (community: Types.CommunityIdentifier, date: Types.SelectedDate, filter?: IsActive.Filter) => DatedInformationAction

export type SelectDateRangeAction =  Redux.Action & Types.DateRange

export type SelectDateRange = Redux.ActionCreator<SelectDateRangeAction>

export const selectDateRange: SelectDateRange = (dateRange: Types.DateRange, eventName: string) =>
  ({
    end: dateRange.end ? Moment(dateRange.end).format('YYYY-MM-DD') : null,
    start: dateRange.start ? Moment(dateRange.start).format('YYYY-MM-DD') : null,
    type: eventName,
  })

export interface SelectDateAction extends Redux.Action {
  date: string,
}

export type SelectDate = Redux.ActionCreator<SelectDateAction>

export const selectDate: SelectDate = (date: Types.SelectedDate, eventName: string) =>
  ({
    date: date ? Moment(date).format('YYYY-MM-DD') : null,
    type: eventName,
  })

export type SelectDateRangeAndFilterAction = Redux.Action & Types.DateRangeAndMode

export type SelectDateRangeAndFilter = Redux.ActionCreator<SelectDateRangeAndFilterAction>

export const selectDateRangeAndFilter: SelectDateRangeAndFilter =
 (dateRangeandMode: Types.DateRangeAndMode, filter: IsActive.Filter, eventName: string) =>
  ({
    dateSelect: dateRangeandMode.dateSelect,
    end: dateRangeandMode.end ? Moment(dateRangeandMode.end).format('YYYY-MM-DD') : null,
    filter,
    start: dateRangeandMode.start ? Moment(dateRangeandMode.start).format('YYYY-MM-DD') : null,
    type: eventName,
  })



// WEBPACK FOOTER //
// ./src/components/date-selector/actions.ts